import script from "./MaterialSelectionView.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialSelectionView.vue?vue&type=script&setup=true&lang=js"

import "./MaterialSelectionView.vue?vue&type=style&index=0&id=67bcf252&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bcf252"]])

export default __exports__